import {defineMessages} from 'react-intl';

const messages = defineMessages({
  submitResults: {
    id: 'submitResults',
    defaultMessage: 'Submit results'
  },
  checklistSummary: {
    id: 'checklistSummary',
    defaultMessage: 'Checklist Summary'
  },
  yourName: {
    id: 'yourName',
    defaultMessage: 'Your name'
  },
  typeInFullName: {
    id: 'typeInFullName',
    defaultMessage: 'Type in full name'
  },
  fillInField: {
    id: 'fillInField',
    defaultMessage: 'Fill in {field}'
  },
  ok: {
    id: 'ok',
    defaultMessage: 'Ok'
  },
  errorSubmittingTitle: {
    id: 'errorSubmittingTitle',
    defaultMessage: 'Unable to submit results'
  },
  errorSubmittingSubtitle: {
    id: 'errorSubmittingSubtitle',
    defaultMessage: 'An error occurred while submitting the results. Please try again.'
  },
  errorFetchingChecklist: {
    id: 'errorFetchingChecklist',
    defaultMessage: 'Could not fetch the checklist.'
  },
  somethingWentWrong: {
    id: 'pdfErrorHeader',
    defaultMessage: 'Something went wrong'
  }
});

export default messages;
